import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useUsersQuery } from '@/services/users'
import { columns } from './columns'
import DataGridTable from '@/components/shared/DataGridTable'

export default function UsersPage() {
  const navigate = useNavigate()

  const { users, count, isLoading, isFetching, dataGridConfig } = useUsersQuery()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        Users
      </Typography>

      <DataGridTable
        {...dataGridConfig}
        rows={users}
        columns={columns}
        rowCount={count}
        loading={isLoading || isFetching}
        showQuickFilter={false}
        onRowClick={params =>
          navigate(`/users/${encodeURIComponent(params.row.email)}`, {
            state: { backLabel: 'Back to Users', fallbackPath: '/users' }
          })
        }
      />
    </Box>
  )
}
